/**
 * Cycles hero product-birth phases; respects prefers-reduced-motion and hover slow-down.
 */
import {useEffect, useState} from 'react';
import {heroIdeaPhaseMs, heroPhaseMs} from "../data";

export const HERO_PHASES = ['idea', 'build', 'intelligence', 'connected', 'production'];

export function useHeroAnimation(hoverSlow = false) {
    const [phase, setPhase] = useState('idea');
    const [reducedMotion, setReducedMotion] = useState(false);

    useEffect(() => {
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const apply = () => {
            const reduced = mq.matches;
            setReducedMotion(reduced);
            if (reduced) setPhase('production');
        };
        apply();
        mq.addEventListener('change', apply);
        return () => mq.removeEventListener('change', apply);
    }, []);

    useEffect(() => {
        if (reducedMotion) return undefined;

        let index = 0;
        let timeoutId;

        const durationForPhase = (phaseId) => {
            const base = phaseId === 'idea' ? heroIdeaPhaseMs : heroPhaseMs;
            return hoverSlow ? Math.round(base * 1.6) : base;
        };

        const scheduleNext = () => {
            const current = HERO_PHASES[index];
            timeoutId = window.setTimeout(() => {
                index = (index + 1) % HERO_PHASES.length;
                setPhase(HERO_PHASES[index]);
                scheduleNext();
            }, durationForPhase(current));
        };

        setPhase(HERO_PHASES[0]);
        scheduleNext();
        return () => window.clearTimeout(timeoutId);
    }, [reducedMotion, hoverSlow]);

    return {phase, reducedMotion};
}
